import { render, staticRenderFns } from "./DepartmentLocation.vue?vue&type=template&id=1ccabb8a&scoped=true&"
import script from "./DepartmentLocation.vue?vue&type=script&lang=js&"
export * from "./DepartmentLocation.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentLocation.vue?vue&type=style&index=0&id=1ccabb8a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccabb8a",
  null
  
)

export default component.exports